import { useTextFilter } from "../../toolympus/components/schemed/Filtering/useTextFilter";
import { useDownloadFile } from "../../toolympus/hooks/useDownloadFile";
import { useLoadedData } from "../../toolympus/hooks/useLoadedData"
import { Course } from "./types"

export const useCourseList = () => {
  const data = useLoadedData<Course[]>("/api/course", []);
  const filter = useTextFilter<Course>(c => c.title);

  const exportAllFiles = useDownloadFile("/api/courses/all-files", `Winter Academy ${new Date().getFullYear()} courses files.zip`);

  return {
    ...data,
    filter,
    data: filter.filterData(data.data),
    exportAllFiles,
  }
}

export type CourseListData = ReturnType<typeof useCourseList>;
